import { useMainContext } from "../../../../context";
import maskMoney from "../../../../utils/maskMoney";
import { useItemPageContext } from "../../context";

const SelectAditionalComponent = () => {
  const { product } = useMainContext();
  const { clickCheckAdditional } = useItemPageContext();

  return (
    <section className="space-y-4">
      {product.groupsAdditionals.length > 0 && (
        <div className="border-2 border-gray-100 overflow-hidden rounded-md shadow">
          <div className="bg-gray-100 p-4 flex items-center justify-between gap-2">
            <p className="text-lg font-bold">Adicionais</p>
            <div className="flex gap-2">
              <span className="text-sm rounded-full px-3 py-1 bg-gray-200">
                Opcional
              </span>
            </div>
          </div>

          <div className="space-y-4 p-4">
            {product.groupsAdditionals.map((groupAdditional, groupIndex) => (
              <div key={groupAdditional.id} className="flex flex-col gap-1">
                <p className="font-bold text-md mb-1">{groupAdditional.name}</p>

                {groupAdditional.additionals.map(
                  (additional, additionalIndex) => (
                    <label
                      key={additional.id}
                      className={`cursor-pointer flex items-center px-4 py-3 rounded-lg hover:bg-gray-200 transition-colors ${additional.status === "block" ? "opacity-50" : ""}`}
                    >
                      <input
                        onChange={() =>
                          additional.status !== "block"
                            ? clickCheckAdditional(groupIndex, additionalIndex)
                            : {}
                        }
                        checked={additional.selected}
                        type="checkbox"
                        disabled={additional.status === "block"}
                        className="hidden peer"
                      />

                      <div className="w-5 h-5 mr-3 border-2 rounded border-gray-400 peer-checked:bg-primary-500 peer-checked:border-primary-500 flex items-center justify-center">
                        <svg
                          className="w-5 h-5 text-white"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          viewBox="0 0 24 24"
                        >
                          <path d="M5 13l4 4L19 7" />
                        </svg>
                      </div>

                      <div className="flex flex-grow justify-between">
                        <p
                          className={`font-bold ${additional.status === "block" ? "line-through" : ""}`}
                        >
                          {additional.name}
                        </p>

                        {additional?.price > 0 && (
                          <span className="text-primary-500 font-bold">
                            + {maskMoney(additional.price)}
                          </span>
                        )}
                      </div>
                    </label>
                  ),
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default SelectAditionalComponent;
